import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Wire from '../common/wire';
import Stats from './stats';
import Separator from './separator';
import ContributorResultsContext from './context';
import useScrollableWires from '../common/scrollable-wires-hooks';
import Tail from '../common/wires-list-tail';
import wireName from '../common/utils';
import {
  useGetPaginatedAllWiresOfContributor,
  useGetPaginatedWiresFromContributor,
  useGetPaginatedWiresMentioningContributor,
} from '../../../services/wires/from-contributor-service';

const TYPES = {
  all: {
    useGetWires: useGetPaginatedAllWiresOfContributor,
    actions: {
      loading: 'setLoadingAllWires',
      wires: 'setAllWires',
    },
  },
  latest: {
    useGetWires: useGetPaginatedWiresFromContributor,
    actions: {
      loading: 'setLoadingLatestWires',
      wires: 'setLatestWires',
    },
  },
  mentions: {
    useGetWires: useGetPaginatedWiresMentioningContributor,
    actions: {
      loading: 'setLoadingMentionedWires',
      wires: 'setMentionedWires',
    },
  },
};

export default function ScrollableWiresList({
  contributorId, contributorName, isScrollable, type,
}) {
  const { dispatch } = React.useContext(ContributorResultsContext);
  const { useGetWires, actions } = TYPES[type];
  const {
    expandList, hasMore, infiniteRef, loading, mentionsTotal,
    rawData, showExpand, total, wires,
  } = useScrollableWires({
    type,
    isScrollable,
    initNumber: 20,
    useGetWires: () => useGetWires(contributorId),
  });

  React.useEffect(() => {
    dispatch({
      type: actions.loading,
      // eslint-disable-next-line no-nested-ternary
      payload: !loading ? null : (wires.length ? 'more' : 'init'),
    });
  }, [loading, dispatch, actions.loading, wires.length]);

  React.useEffect(() => {
    _.get(rawData, 'wires.length') && dispatch({ type: actions.wires, payload: rawData.wires });
  }, [rawData, dispatch, actions.wires]);

  const common = {
    type, total, contributorName, mentionsTotal,
  };

  return (
    <>
      <Stats {...common} />
      {!!wires.length && (
        <article>
          {wires.map((wire, index) => (
            <div name={wireName(type, index)} key={`${type}-wire-${wire.id}`}>
              <Wire
                bordered={false}
                wire={wire}
                showMention={wire.profile.id !== contributorId}
                position={index + 1}
              />
            </div>
          ))}
          <div ref={infiniteRef} />
          {!!showExpand && (
            <Tail><button type="button" onClick={expandList}>see all results</button></Tail>
          )}
          {!hasMore && <Tail><span>You have seen all the results</span></Tail>}
        </article>
      )}
      <Separator type={type} />
    </>
  );
}

ScrollableWiresList.propTypes = {
  contributorId: PropTypes.number.isRequired,
  contributorName: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['all', 'latest', 'mentions']).isRequired,
  isScrollable: PropTypes.bool,
};

ScrollableWiresList.defaultProps = {
  isScrollable: false,
};
